'use client';

import { c as _c } from "react/compiler-runtime";
import { type ComponentProps } from 'react';
import { InstallPWAPrompt } from '@shared/ui-components/install-pwa-prompt/install-pwa-prompt';
import { useInstallPromptCoordination } from '../providers/install-prompt-coordination-context';
type InstallPwaPromptGateProps = Omit<ComponentProps<typeof InstallPWAPrompt>, 'canShow' | 'onActiveChange'>;
export const InstallPwaPromptGate = props => {
  const $ = _c(4);
  const {
    isPushPromptActive,
    setIsPwaPromptActive
  } = useInstallPromptCoordination();
  const t0 = !isPushPromptActive;
  let t1;
  if ($[0] !== props || $[1] !== setIsPwaPromptActive || $[2] !== t0) {
    t1 = <InstallPWAPrompt {...props} canShow={t0} onActiveChange={setIsPwaPromptActive} />;
    $[0] = props;
    $[1] = setIsPwaPromptActive;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};